/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { StoricoIsee } from './storicoIsee';
import { Studente } from './studente';

export interface Anagrafica { 
    id?: string;
    annoDiRiferimento?: string;
    nome?: string;
    cognome?: string;
    codicePratica?: string;
    codiceFiscale?: string;
    comuneNascita?: string;
    provinciaNascita?: string;
    dataNascita?: string;
    comuneResidenza?: string;
    indirizzoResidenza?: string;
    provinciaResidenza?: string;
    cittadinanza?: string;
    cellulare?: string;
    possessoIsee?: boolean;
    isResidente?: boolean;
    isee?: number;
    storicoIsee?: Array<StoricoIsee>;
    studenti?: Array<Studente>;
    created_at?: Date;
    updated_at?: Date;
}